module.exports = __webpack_public_path__ + "static/media/android-location-settings.fa9bebbf.png";